export const initialValuesAccount = {
  first_name: "",
  last_name: "",
  phone: "",
  skype: "",
};
